<template>
<!--Select profile from frontpage-->
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" class=" pl-2">
        {{ $t("navbar.general.Profile") }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in profil" :key="index" :to="item.link">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// i18n imported
import messages from "../../modules/lang/export";
export default {
  // i18n used
  i18n: { messages },
  data() {
    return {
      profil: [
        // { name: this.$t("navbar.general.User dashboard"), link: "private" },
        {
          name: this.$t("navbar.general.User profile"),
          link: "private/profilesettings/profile"
        },
        {
          name: this.$t("navbar.general.Frontpage Feeds"),
          link: "private/profilesettings/frontpage"
        },
        {
          name: this.$t("navbar.general.Your Articles"),
          link: "private/articles/list"
        },
        {
          name: this.$t("navbar.general.Create Article"),
          link: "private/articles/create"
        },
        // {name: this.$t("navbar.general.Inbox"), link:"private/inbox"},
        // { name: this.$t("navbar.general.Follows"), link: "private/follows" },
        { name: this.$t("navbar.general.Logout"), link: "logout" }
      ]
    };
  }
};
</script>
